import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";

export interface ConditionalParametersRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: ConditionalParametersRoute[];
}

export const conditionalParametersRoutes: ConditionalParametersRoute[] = [
  {
    path: "/ax/settings/conditional-parameters",
    element: <Landing />,
  },
];